var StatsVariant;
(function (StatsVariant) {
  StatsVariant["positive"] = "positive";
  StatsVariant["negative"] = "negative";
  StatsVariant["neutral"] = "neutral";
  StatsVariant["neutralVariant"] = "neutralVariant";
  StatsVariant["attention"] = "attention";
  StatsVariant["informative"] = "informative";
})(StatsVariant || (StatsVariant = {}));
var StatsSize;
(function (StatsSize) {
  StatsSize["large"] = "large";
  StatsSize["small"] = "small";
  StatsSize["tiny"] = "tiny";
})(StatsSize || (StatsSize = {}));
var StatsIcon;
(function (StatsIcon) {
  StatsIcon["up"] = "up";
  StatsIcon["down"] = "down";
})(StatsIcon || (StatsIcon = {}));

export { StatsIcon, StatsSize, StatsVariant };
